import { Toggle, IconButton, Popover } from '@nexelem/components';
import { useGanttSimulationContext } from '../hooks';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck, faCircleInfo, faCircleQuestion, faSnowflake } from '@fortawesome/pro-light-svg-icons';
import { useCustomTranslation } from '../../../../../hooks';
import { Trans } from 'react-i18next';

export const SimulationModeToggle = () => {
  const { mode, setMode } = useGanttSimulationContext();
  const { t, tWrapper } = useCustomTranslation('products.simulationPlan');

  return (
    <div className="ml-6 flex items-center gap-2">
      <span className="text-s11-sb text-text-secondary uppercase">{t('common.mode')}</span>
      <Popover.Root>
        <Popover.Trigger>
          <IconButton Icon={<FontAwesomeIcon icon={faCircleQuestion} />} />
        </Popover.Trigger>
        <Popover.Content>
          <Trans components={{ ul: <ul className="mt-0 ml-1 list-inside list-disc" />, li: <li /> }}>
            {tWrapper('modeDescription')}
          </Trans>
        </Popover.Content>
      </Popover.Root>
      <Toggle.Root value={mode} onChange={setMode}>
        <Toggle.Button StartIcon={<FontAwesomeIcon icon={faCircleInfo} />} value="DEFAULT">
          {tWrapper('details')}
        </Toggle.Button>
        <Toggle.Button StartIcon={<FontAwesomeIcon icon={faSnowflake} />} value="FREEZING">
          {tWrapper('freezing')}
        </Toggle.Button>
        <Toggle.Button StartIcon={<FontAwesomeIcon icon={faCircleCheck} />} value="PUBLICATION">
          {tWrapper('publication')}
        </Toggle.Button>
      </Toggle.Root>
    </div>
  );
};
